import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Product } from '../../models/products/product.model';
import { Warranty, ReturnPolicy } from '../../models/warranty-type/warranty-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class ProductService {
  private service = "api/Products"; //Controller Name
  private utilityService = "api/Utility";
  public Product: Product[];
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  AddProduct(formData: Product[]){
    return  this.http
      .post(`${this.service}/AddProduct`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddUpdateProduct(formData: Product[]) {
    return this.http
      .post(`${this.service}/AddUpdateProduct`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetProductById(id: number) {
    return this.http.get(`${this.service}/GetProductById?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateVariableProduct(formData: Product[]) {
    return this.http
      .post(`${this.service}/UpdateVariableProduct`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateSimpleProduct(formData: Product[]) {
    return this.http
      .post(`${this.service}/UpdateSimpleProduct`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateVariableSimpleProduct(formData: Product[]) {
    return this.http
      .post(`${this.service}/UpdateVariableSimpleProduct`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  AddAttribute(formData: any) {
    return this.http
      .post(`${this.service}/AddAttribute`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddVariant(formData: any) {
    return this.http
      .post(`${this.service}/AddVariant`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  deleteAttribute(id: string) {
    return this.http.delete(`${this.service}/DeleteAttribute?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  DeleteVariant(id: string) {
    return this.http.delete(`${this.service}/DeleteVariant?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  DeleteProductImages(id: string) {
    return this.http.delete(`${this.service}/DeleteProductImages?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }

  GetProductVariations(id: string) {
    return this.http.get(`${this.service}/GetProductVariations?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetVariants(ids: string) {
    return this.http.get(`${this.service}/GetVariants?ids=` + ids, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetWarranties() {
    return this.http.get(`${this.service}/GetWarranties`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  DeleteWarranty(id: string) {
    return this.http.get(`${this.service}/DeleteWarranty?Id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  addWarrantyType(model: Warranty) {
    return this.http.post(`${this.service}/InsertWarrantyType`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getActiveWarranties() {
    return this.http.get(`${this.service}/GetActiveWarranties`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateWarranty(model: Warranty) {
    return this.http.post(`${this.service}/UpdateWarrantyType`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getWarrantyById(Id: string) {
    return this.http.get(`${this.service}/GetWarrantyById?Id=` + Id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //Return Policy

  GetReturnPolicy() {
    return this.http.get(`${this.service}/GetReturnPolicy`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetActiveReturnPolicy() {
    return this.http.get(`${this.service}/GetActiveReturnPolicy`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  DeleteReturnPolicy(id: string) {
    return this.http.get(`${this.service}/DeleteReturnPolicy?Id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  addReturnPolicy(model: ReturnPolicy) {
    return this.http.post(`${this.service}/InsertReturnPolicy`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateReturnPolicy(model: ReturnPolicy) {
    return this.http.post(`${this.service}/UpdateReturnPolicy`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getReturnPolicyById(Id: string) {
    return this.http.get(`${this.service}/GetReturnPolicyById?Id=` + Id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetProductStatus() { 
    return this.http.get(`${this.utilityService}/GetProductStatuses`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  ExportProducts(ProductList: any) {
    
    if (ProductList == null) { ProductList = []; }
    var vendorId = 0;

    return this.http.post(`${this.service}/ExportProducts?vendorID=` + vendorId, ProductList, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  SaleProductUpload(formData: any) {
    return this.http
      .post(`${this.service}/SaleProductUpload`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }



  ExportSaleProducts(ProductList: any) {

    if (ProductList == null) { ProductList = []; }
    var vendorId = 0;

    return this.http.post(`${this.service}/ExportSaleProducts`,ProductList, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  SampleSaleProducts() {
    return this.http.get(`${this.service}/SampleSaleProducts`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  

  GetAttributeList() {
    return this.http.get(`${this.service}/GetAttributeList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAttribute(id: string) {
    return this.http.get(`${this.service}/GetAttribute?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetVariantsList(id: number) {
    return this.http.get(`${this.service}/GetVariantsList?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAllVariantsList() {
    return this.http.get(`${this.service}/GetAllVariants`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  DeleteProduct(id: string) {
    return this.http.delete(`${this.service}/DeleteProduct?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  //passing ParentCategoryID 0 to get first level categories
  GetProductList(type: string) {
    return this.http.get(`${this.service}/GetProducts?Type` + type, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetProductByVendor(type: number) {
    return this.http.get(`${this.service}/GetProductsByVendor?vendorID=` + type, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetProducts() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //passing text 0 to get  relevent Text Product
  ProductSuggestions(text: string) {
    return this.http.get(`${this.service}/ProductSuggestions?search=` + text, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  ProductSuggestionsByVendor(text: string, id: number) {
    return this.http.get(`${this.service}/ProductSuggestionsByVendorId?search=` + text + `&vendorId=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  ProductBulk(text: string) {
    return this.http.get(`${this.service}/ProductBulk?search=` + text, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAdminGridProducts(isActive: string, isFeature: string, inStock: string, CategoryID, CategoryType: number, brandID: number, productStatusId: number, vendorID: number, searchKeyword: string, PageNumber: number, PageSize: number) {
    return this.http.get(`${this.service}/GetAdminGridProducts?isActive=` + isActive + '&isFeature=' + isFeature + '&inStock=' + inStock + '&CategoryID=' + CategoryID + '&CategoryType=' + CategoryType + '&brandID=' + brandID + '&productStatusId=' + productStatusId + '&vendorID=' + vendorID + '&searchKeyword=' + searchKeyword + '&PageNumber=' + PageNumber + '&PageSize=' + PageSize, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetExportProducts(isActive: string, isFeature: string, inStock: string, CategoryID, CategoryType: number, brandID: number, productStatusId: number, vendorID: number, searchKeyword: string) {
    return this.http.get(`${this.service}/GetExportProducts?isActive=` + isActive + '&isFeature=' + isFeature + '&inStock=' + inStock + '&CategoryID=' + CategoryID + '&CategoryType=' + CategoryType + '&brandID=' + brandID + '&productStatusId=' + productStatusId + '&vendorID=' + vendorID + '&searchKeyword=' + searchKeyword, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateProductStatusBulk(ProductList: any, StatusId: any) {
    return this.http.post(`${this.service}/UpdateProductStatusBulk?statusId=` + StatusId, ProductList, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetMasterProduct(id:string) {
    return this.http.get(`${this.service}/GetMasterProduct?ID=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetMasterVaribaleProduct(master: string, variant: string) {
    return this.http.get(`${this.service}/GetMasterVaribaleProduct?Master=` + master + `&Variant=` + variant, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetProductsByParentProductID(id: number) {
    return this.http.get(`${this.service}/GetProductsByParentProductID?ID=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  Products_ExportToExcel(data:any) {
    return this.http.post(`${this.service}/Products_ExportToExcel`, data, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //XLSX.writeFile(workbook, ProductService.toExportFileName(excelFileName));
  }


  BulkUploadingProducts(formData: any) {
    return this.http
      .post(`${this.service}/UploadFiles`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getProductColumns(){
    return this.http.get(`${this.service}/GetProductColumns`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
    .map((response: Response) => response.json())
    .catch(this.errorHandler);
  }
  GetColumnsUploadFile(formData: any) {
    return this.http
      .post(`${this.service}/GetColumnsFromExcelFile`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  ReadCompleteFile(formData: any) {
    return this.http
      .post(`${this.service}/ReadCompleteFile`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) =>
        response.json())
      .catch(this.errorHandler);
  }

  SyncPictures() { 
    return this.http
      .get(`${this.service}/SyncPictures`, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) =>
        response)
      .catch(this.errorHandler);
  }

  SyncPicturesRemCount() {
    return this.http.get(`${this.service}/SyncPicturesRemCount`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  toggleButtonAnimation(btn:any) {
    if (btn.nativeElement.firstElementChild.hidden) {
      btn.nativeElement.disabled = false;
      btn.nativeElement.firstElementChild.hidden = false;
      btn.nativeElement.lastElementChild.hidden = true;
     
    }
    else {
      btn.nativeElement.disabled = true;
      btn.nativeElement.firstElementChild.hidden = true;
      btn.nativeElement.lastElementChild.hidden = false;
      
    }
  }

  FetchProductByCategoryID(categoryID: number) {
    return this.http.get(`${this.service}/FetchProductsByCategoryID?categoryID=` + categoryID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/product/product.service.ts